import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import StyledInput from '../../styled/input';
var PickerInput = styled(StyledInput)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    :hover {\n        cursor: pointer;\n    }\n\n    &[disabled] {\n        cursor: not-allowed;\n    }\n"])));
export default PickerInput;